var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'tw-flex tw-cursor-pointer tw-flex-nowrap tw-items-center tw-rounded-full tw-font-inter',
    {
      'hover:tw-bg-surface-medium active:tw-bg-secondary-light': !_setup.props.disabled,
      'tw-px-3 tw-py-2.5': !_vm.mini,
      'tw-justify-center': _vm.mini,
      '!tw-bg-secondary-light': !_setup.props.disabled && _vm.isActive,
    },
  ],on:{"click":(e) => _setup.emit('click')}},[_c('div',{staticClass:"tw-flex tw-flex-nowrap tw-items-center"},[_c(_setup.AppIcon,{staticClass:"tw-fill-blue-gray-700",class:{ 'tw-fill-blue-gray-300': _vm.disabled, '!tw-fill-blue-500': !_setup.props.disabled && _vm.isActive },attrs:{"size":24,"icon":_setup.props.prependIcon}}),(!_vm.mini)?_c('span',{staticClass:"tw-ml-3 tw-text-sm tw-font-medium tw-tracking-[0.1px] tw-text-body-1",class:{ 'tw-truncate': _setup.props.truncate, '!tw-text-blue-500': !_setup.props.disabled && _vm.isActive }},[_vm._v(_vm._s(_setup.props.text))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }